import React, { Component } from 'react'
import "./createstudy.css"
import {
  Container,
  Form,
  Button,
  NavLink,
  Spinner
} from 'reactstrap';
import Game from "../../../src/components/Picture/สมัยก่อนประวัติศาสตร์.JPG";
import Lightbox from "react-image-lightbox";

class CreateStudy4 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }
  render() {
    const { isOpen } = this.state;
    return (
      
      <div>
        <Container className="comming">
        <Form className="boxstudy4">
        <h1 className="textstudy">เรื่องสมัยก่อนประวัติศาสตร์ในดินแดนไทย</h1><br></br>

        <Form className="b1"><h5 className="textS">1. ปัจจัยที่ผลต่อการตั้งถิ่นฐานของมนุษย์ในดินแดนไทย</h5>
        <h5 className="dd"><Spinner type="grow" color="info" />1.1 ปัจจัยทางกายภาพ</h5>
        <h5 className="dd">1. ทำเลที่ตั้ง อยู่กึ่งกลางระหว่างอารยธรรมจีนและอินเดีย และตั้งอยู่ในเส้นทางการค้าระหว่างตะวันออกกับตะวันตก</h5>
        <h5 className="dd">2. ลักษณะภูมิประเทศ</h5>
        
        <h5 className="dd2"> 
          ภาคเหนือ เป็นทิวเขาสลับที่ราบหุบเขา<br></br>
          ภาคตะวันออกเฉียงเหนือ เป็นที่ราบสูง<br></br>
          ภาคกลาง เป็นที่ราบลุ่มแม่น้ำ<br></br>
          ภาคตะวันตก เป็นทิวเขาสลับที่ราบหุบเขา<br></br>
          ภาคตะวันออก เป็นทิวเขาและที่ราบชายฝั่งทะเล<br></br>
          ภาคใต้ เป็นทิวเขามีที่ราบชายฝั่งทะเลทั้งสองด้านของคาบสมุทร<br></br></h5>
        <h5 className="dd">3. ภูมิอากาศ อยู่ในเขตของลมมรสุมตะวันตกเฉียงใต้ ทำให้มีฝนตก และลมมรสุมตะวันออกเฉียงเหนือทำให้อากาศหนาว</h5>
        <h5 className="dd">4. ทรัพยากรธรรมชาติ ประเทศไทยเต็มไปด้วยทรัพยากรธรรมชาติ เช่น ป่าไม้ แหล่งน้ำ และมีแร่ธาตุ ได้แก่ ทองแดง ดีบุก เหล็ก</h5>
        <h5 className="dd"><Spinner type="grow" color="info" />1.2 ปัจจัยทางสังคม</h5>
        <h5 className="dd">ตั้งแต่เริ่มมีการตั้งถิ่นฐานถาวรในยุคหินใหม่ โครงสร้างทางสังคมก็มีความซับซ้อนขึ้น มีหัวหน้าปกครอง มีกฎเกณฑ์ต่าง ๆ มีการแบ่งงานกันทำ มีการค้าขายแลกเปลี่ยน มีการแบ่งชนชั้น มีการผสมผสานทางวัฒนธรรม</h5></Form>
        <Form className="b1"><h5 className="textS">2. การศึกษาเรื่องราวสมัยก่อนประวัติศาสตร์ในประเทศไทย</h5></Form>
        
            <img className="photo4"
              width="700"
              height="700"
          onClick={() => this.setState({ isOpen: true })}
          src={Game}
          alt="QRcode"
          
        ></img>
        {isOpen && (
          <Lightbox
            mainSrc={Game}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
        
        <Form className="b1"><h5 className="textS">3. ยุคหินในดินแดนไทย</h5>
        <h5 className="dd"><Spinner type="grow" color="primary" />3.1 ยุคหินเก่า 500,000–10,000 ปีมาแล้ว</h5>
        <h5 className="dd">หลักฐานเก่าแก่ที่มีการค้นพบ ได้แก่ เครื่องมือหินกะเทาะ เป็นเครื่องมือของมนุษย์โบราณพวก โฮโมอีเรกตัส (Homo erectus)
          มนุษย์ในยุคนี้ดำรงชีวิตด้วยการล่าสัตว์ รู้จักใช้ไฟ ไม่มีถิ่นฐานที่แน่นอน พบหลักฐานว่าอาศัยตามถ้ำ</h5>
          <h5 className="dd"><Spinner type="grow" color="primary" />3.2 ยุคหินกลาง 10,000–6,000 ปีมาแล้ว</h5>
          <h5 className="dd">พบเครื่องมือหินกะเทาะ แบบฮัวบิเนียน (Hoabinhian) พบครั้งแรกที่ จังหวัดฮัวบินห์ ประเทศเวียดนาม
          ยุคหินกลางเป็นช่วงสิ้นสุดสมัยน้ำแข็ง ทำให้ระดับน้ำทะเลค่อย ๆ สูงขึ้นเกิดหมู่เกาะต่าง ๆ มนุษย์ในยุคนี้ตั้งถิ่นฐานอยู่ในถ้ำ เพิงผา ดำรงชีวิตด้วยการล่าสัตว์ มีพิธีฝังศพ แสดงถึงความเชื่อหลังการตาย</h5>
          <h5 className="dd">เครื่องมือเครื่องใช้ที่พบ คือ เครื่องมือหินขัด ที่สำคัญคือ ขวานหินขัด ชาวบ้านบางแห่งเรียก ขวานฟ้า
          ยังมีค้นพบเครื่องมือเครื่องใช้อื่น ๆ เช่น เครื่องปั้นดินเผา ภาชนะ เช่น หม้อ ไห
          ยุคหินใหม่เป็นยุคเกษตรกรรม พืชที่สำคัญ คือ ข้าว มีการเลี้ยงสัตว์ เช่น สุนัข หมู วัว ควาย
          หลักฐานที่สำคัญ อีกอย่าง คือ หลุมฝังศพ ภายในหลุมมี อาหาร ภาชนะดินเผา ขวานหินขัด บางครั้งพบพิธีกรรมที่ทำกับศพ เช่น มัดศพ กรอฟันศพ
          สังคมในยุคหินใหม่อาศัยใกล้แหล่งน้ำอยู่รวมเป็นหมู่บ้าน พึ่งพาเกษตรกรรม สังคมมีความซับซ้อนขึ้น จึงมีความแตกต่างทางฐานะในสังคม และมีการติดต่อระหว่างชุมชน</h5>
        </Form>
        <Form className="b1"><h5 className="textS">4. ยุคโลหะในดินแดนไทย</h5>
        <h5 className="dd"><Spinner type="grow" color="success" />4.1 ยุคสำริด 4,000–2,500 ปีมาแล้ว</h5>
        <h5 className="dd">มนุษย์รู้จักการนำสำริดมาทำเป็นเครื่องมือเครื่องใช้ เครื่องใช้สำริดที่สำคัญ คือ กลองมโหระทึก ซึ่งใช้ในพิธีกรรม
        มนุษย์ยุคสำริดยังคงดำเนินชีวิตด้วยการเกษตร มีการเพาะปลูกและเลี้ยงสัตว์ มีการตั้งถิ่นฐานและพิธีศพเหมือนยุคหินใหม่</h5>
        <h5 className="dd"><Spinner type="grow" color="success" />หลักฐานยุคเหล็กมักพบในแหล่งเดียวกับยุคสำริดยังคงใช้สำริดทำเครื่องมือเครื่องประดับ ยังดำรงชีวิตด้วยการเกษตร สังคมมีขนาดใหญ่ขึ้นมาก มีการพัฒนาเป็นชุมชนเมืองที่มีคูน้ำและคันดินเป็นกำแพงในสมัยต่อมา</h5>
        </Form>
        <Form className="b1"><h5 className="textS">5. ตัวอย่างแหล่งโบราณคดีในประเทศไทย</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" /> 5.1 แหล่งโบราณคดีบ้านเก่า จังหวัดกาญจนบุรี</h5>
        <h5 className="dd">พบโครงกระดูก ภาชนะดินเผายุคหินใหม่เป็นจำนวนมาก และหม้อสามขา ซึ่งถือว่าเป็นสัญลักษณ์ของยุคหินใหม่</h5>
        <h5 className="dd"><Spinner type="grow" color="warning" />5.2 แหล่งโบราณคดีบ้านเชียง จังหวัดอุดรธานี</h5>
        <h5 className="dd">เป็นแหล่งโบราณคดีสมัยก่อนประวัติศาสตร์ในยุคโลหะ พบเครื่องปั้นดินเผาเป็นภาชนะลายเขียนสีแดงบนพื้นสีขาวนวล และยูเนสโกประกาศให้บ้านเชียงเป็นมรดกโลกทางวัฒนธรรม
          จากหลักฐานทางโบราณคดีที่พบ แสดงว่าอยู่รวมกันเป็นหมู่บ้าน ดำรงชีวิตด้วยการเกษตร เครื่องมือระยะแรกเป็นขวานหินขัด ต่อมาเริ่มมีการทำเครื่องมือเครื่องประดับจากสำริด และในที่สุดพัฒนาเป็นเครื่องมือเครื่องใช้ที่ทำจากเหล็ก</h5>
          <img className="photo4" width="600" height="400" src="/img/img1/แหล่งโบราณ.JPG" ></img>
        </Form>
        <Form className="b1"><h5 className="textS">6. ศิลปะถ้ำสมัยก่อนประวัติศาสตร์</h5>
        <h5 className="dd">ภาพที่คนก่อนประวัติศาสตร์ทำไว้ตามผนังถ้ำและเพิงผา โดยลงสีเป็นภาพคน ภาพมือ ภาพสัตว์ และภาพเรขาคณิต บางครั้งเป็นภาพพิธีกรรม สีที่ใช่ส่วนใหญ่เป็นสีแดง รองลงมาสีขาวและสีดำ ไม่พบสีอื่น ภาพเหล่านี้ไม่สามารถกำหนดอายุได้ แต่อาจใช้หลักฐานอื่น ๆ ที่พบในถ้ำบอกยุคสมัยและเปรียบเทียบอายุของภาพได้</h5>
        </Form>
        
        <p h5 align='center'><Button href='/study' outline color="warning" >ย้อนกลับ</Button>{' '}</p>
          <p h5 align='center'><Button href='/createStudy5' outline color="primary" >บทถัดไป</Button>{' '}</p>
        
        </Form>
        </Container>

        <div className="footer text-footer">
          <p>Surasak   Noorurk</p>
          <p> Project 5935512072 Computer Engineering</p>           
          <NavLink href="https://surasak783023869.wordpress.com/">ช่องทางการติดต่อ</NavLink>
        </div>

      </div>
    )
  }
}

export default CreateStudy4